import type { UIMatch } from 'react-router';
import type { RouteLayout } from '@/routes/Router';

import { useMatches } from 'react-router';
import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { CoreWrapper } from '@/components/wrapper/CoreWrapper';
import { ToastProvider } from '../../../components/Toast';
import { routes } from '../../../constants/Constants';
import { useUrlChecker } from '../../../hooks/useUrlChecker';
import ProfileDrawer from '../../ProfileDrawer';
import SideMenu from '../../SideMenu/V2';
import SiteFooter from '../../SiteFooter';
import SiteFooterPublic from '../../SiteFooterPublic';
import SiteHeaderV2 from '../../SiteHeader/V2';

type Props = {
  children: JSX.Element[] | JSX.Element;
};

type RouteHandle = {
  layout?: RouteLayout;
};

const PageWrapper = ({ children }: Props) => {
  const { isPublic } = useUrlChecker();
  const preRegister = isPublic || window.location.pathname === routes.unitsOwnedEnroll;
  const matches = useMatches() as UIMatch<unknown, RouteHandle>[];
  const currentRoute = matches[matches.length - 1];
  const isSplitView = currentRoute?.handle?.layout === 'split-view';

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CoreWrapper>
        <ToastProvider>
          <Box sx={{ display: 'flex', flexDirection: 'row', minHeight: '100vh' }}>
            {preRegister ? null : <SideMenu />}
            <div id="page-container" style={{ flex: 1 }}>
              <SiteHeaderV2 isSplitView={isSplitView} />
              <Box
                sx={{
                  px: { xs: 2, md: isPublic ? 0 : 2 },
                  transition: 'margin 0.3s linear',
                }}
              >
                <Box sx={{ margin: { xl: '0 auto' }, minHeight: 'calc(100vh - 356px)' }}>
                  {children}
                </Box>
                {isPublic ? null : <SiteFooter isSplitView={isSplitView} />}
              </Box>
              {isPublic ? <SiteFooterPublic /> : null}
              <ProfileDrawer />
            </div>
          </Box>
        </ToastProvider>
      </CoreWrapper>
    </LocalizationProvider>
  );
};

export default PageWrapper;
